<template>
  <div :class="wrapperClass">
    <!-- Badge NUEVO -->
    <span v-if="item.badgenuevo" class="badge bg-success me-2" :style="fontStyle">
      Nuevo
    </span>

    <!-- Badge RECOMENDACIÓN -->
    <span v-if="isEspecial" class="badge-vino-fino me-2" :style="fontStyle">
      <i class="bx bx-crown"></i> Recomendación para ti
    </span>

    <!-- 🔥 Top Ventas General -->
    <template v-if="item.mejoresventas">
      <span v-if="isCurrentRoute('topventas', { tipoRanking: 'general' })"
        class="badge-vino-naranja me-2 disabled-badge" :style="fontStyle">
        <i class="bx bx-award"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° en Top Ventas` : 'Top Ventas' }}
      </span>
      <router-link v-else :to="{ name: 'topventas', query: { tipoRanking: 'general' } }" class="badge-vino-naranja me-2" style="text-decoration: none; cursor: pointer;"
        :style="fontStyle">
        <i class="bx bx-award"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° en Top Ventas` : 'Top Ventas' }}
      </router-link>
    </template>

    <!-- 🔥 Top Ventas por Línea -->
    <template v-else-if="item.mejoresventaslineas">
      <span v-if="isCurrentRoute('topventaslinea', { idLinea: item.id_linea, tipoRanking: 'linea' })"
        class="badge-vino-azul me-2 disabled-badge" :style="fontStyle">
        <i class="bx bx-star"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° en Top Ventas Línea` : 'Top Ventas Línea' }}
      </span>
      <router-link v-else style="text-decoration: none; cursor: pointer;"
        :to="{ name: 'topventaslinea', query: { idLinea: item.id_linea, nombre: item.linea, tipoRanking: 'linea' } }"
        class="badge-vino-azul me-2" :style="fontStyle">
        <i class="bx bx-star"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° en Top Ventas Línea` : 'Top Ventas Línea' }}
      </router-link>
    </template>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
  name: 'BadgesProducto',
  props: {
    item: { type: Object, required: true },
    wrapperClass: { type: String, default: 'd-flex flex-wrap gap-2 justify-content-end' },
    fontSize: { type: String, default: '10px' }
  },
  setup() {
    const route = useRoute();

    // 🔹 Función para comparar ruta actual
    function isCurrentRoute(name, query = {}) {
      if (route.name !== name) return false;
      // Compara query params
      for (const key in query) {
        if (route.query[key] != query[key]) return false;
      }
      return true;
    }

    return { route, isCurrentRoute };
  },
  computed: {
    isEspecial() {
      const val = this.item.especial;
      return val && val.toString().toLowerCase() !== 'false';
    },
    fontStyle() {
      return { fontSize: this.fontSize };
    }
  }
};
</script>

<style>
.disabled-badge {
  cursor: default;
  pointer-events: none;
  /* bloquea clic */
  opacity: 0.7;
  /* visualmente deshabilitado */
}
</style>
